import axios from "axios";

export default function exportTransactionReport({ date, format }) {
  return axios.get(
    `/campaignV2/transactionReport/ExportReportDetails?date=${date}&format=${format}`,
    { responseType: "blob" }
  );
}
